import { COOKIES } from './../constants';

const getCookieValue = (a: string) => {
  try {
    const v = document.cookie.match('(^|;)\\s*' + a + '\\s*=\\s*([^;]+)');
    return v ? v.pop() : '';
  } catch (e) {
    /* Swallow Error */
  }
};

export const getWixCustomerId = () => {
  const str = getCookieValue(COOKIES.WIX_UID);
  if (str) {
    const arr = str.split('|');
    if (arr) {
      return arr[0];
    }
  }
  return '';
};
